import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    theme: {
      validations: []
    },
    plannedguestcount: {
      validations: []
    },
    eventDate: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please fill out this field.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please fill out this field.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please fill out this field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please fill out this field.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    accountextra1: {
      validations: []
    },
    accountextra2: {
      validations: []
    },
    accountextra3: {
      validations: []
    },
    accountextra4: {
      validations: []
    },
    accountextra5: {
      validations: []
    },
    accountextra6: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'multiple-choice-nolabel',
            size: 'Medium',
            label: 'Select your event type',
            options: [
              { label: 'Wedding', value: 'Wedding' },
              { label: 'Corporate', value: 'Corporate' },
              { label: 'Magleby\'s Grotto (Private Venue)', value: 'Magleby\'s Grotto (Private Venue)' },
              { label: 'Other', value: 'Other' }
            ],
            mapping: 'theme',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice-nolabel',
            size: 'Medium',
            label: 'How many guests do you estimate?',
            options: [
              { label: '1-10', value: '1-10' },
              { label: '11-50', value: '11-50' },
              { label: '51-100', value: '51-100' },
              { label: '101-200', value: ' 101-200' },
              { label: '200+', value: '200+' },
            ],
            mapping: 'plannedguestcount',
            customClasses: ['no-label']
          }
        ]
      },
    {
      fields: [
        {
          type: 'date-picker',
          size: 'Medium',
          label: 'Click to enter your event date',
          mapping: 'eventDate',
          customClasses: ['no-label']
        }
      ]
    },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name ',
            mapping: 'firstName',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name',
            mapping: 'lastName',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email Address',
            mapping: 'email',
            customClasses: ['no-label']
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number',
            mapping: 'telNumber',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'page',
            mapping: 'accountextra1'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'utm_source',
            mapping: 'accountextra2'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'utm_medium',
            mapping: 'accountextra3'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'utm_campaign',
            mapping: 'accountextra4'
      },{
            type: 'text',
            size: 'Medium',
            label: 'utm_term',
            mapping: 'accountextra5'
      },{
            type: 'text',
            size: 'Medium',
            label: 'utm_content',
            mapping: 'accountextra6'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Get A Free Quote Now!'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Magleby\'s Restaurant & Catering Quote Form',
    formId: '551',
    clientKey: '21E3DABF-D8FC-49AE-9168-CA9C0179646B',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/maglebys2/form_structure.js